<app-scroll-top *ngIf="coreConfig.layout.scrollTop"></app-scroll-top>
